import axios from './axiosService';

/**
 * MLD-4550
 */
export default {
  getTeamStats() {
    return axios.get(`/api/mailgun/previews/team/stats`)
      .then(response => response.data);
  },
  getClients() {
    return axios.get(`/api/mailgun/previews/clients`)
      .then(response => response.data);
  },
  getTests() {
    return axios.get(`/api/mailgun/previews`)
      .then(response => response.data);
  },
  createTest(form) {
    return form.post(`/api/mailgun/previews`)
      .then(response => response.data);
  },
  getPreview(previewID, updateResults = false) {
    const options = {
      params: {
        update_results: updateResults ? 1 : 0,
      }
    };
    return axios.get(`/api/mailgun/previews/${previewID}`, options)
      .then(response => response.data);
  },
  getResults(previewID) {
    return axios.post(`/api/mailgun/previews/${previewID}/results`)
      .then(response => response.data);
  },
  reprocessScreenshot(previewID, clientID) {
    const form = {
      'clients': [
        clientID
      ],
    }
    return axios.put(`/api/mailgun/previews/${previewID}/results/reprocess`, form)
      .then(response => response.data);
  },
  getContentHTML(previewID) {
    return axios.post(`/api/mailgun/previews/${previewID}/content`)
      .then(response => response.data);
  },
  getInlineCSS(previewID) {
    return axios.post(`/api/mailgun/previews/${previewID}/content/inlinecss`)
      .then(response => response.data);
  },
}
